import { RedesignNavbar } from 'root/src/client/v2/layout/features/RedesignNavbar/RedesignNavbar';
import { RedesignGridBackground } from 'root/src/client/v2/layout/features/RedesignLayout/RedesignGridBackground';
import { RedesignDiscordWidget } from 'root/src/client/v2/layout/features/RedesignLayout/RedesignDiscordWidget';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Shared chrome for every redesign page: the `.redesign` style scope, the full-height
// background, the ambient grid backdrop, and the fixed RedesignNavbar. Page content controls its
// own top spacing, because it differs by intent: hero pages bleed their background up under the
// (transparent) navbar, while content pages offset with REDESIGN_NAV_OFFSET_CLASS. See redesignNavbar.ts.
//
// `isolate` makes this a stacking context so the grid backdrop (fixed, -z-10) paints above the opaque
// bg-background but below all page content, without every page having to wrap its content in a layer.
export const RedesignLayout = ({ children, className, discordWidget = true }) => (<div className={cn('redesign isolate min-h-screen bg-background text-foreground', className)}>
		<RedesignGridBackground />
		<RedesignNavbar />
		{children}
		{discordWidget && <RedesignDiscordWidget />}
	</div>);
